import React, { FCWithChildren, useMemo } from 'react';
import { Preferences } from '@interfaces/models/preferences';
import useLocalCountries from '@hooks/use-local-countries';

type PreferencesProviderProps = {
  preferences: Preferences;
};

type PreferencesContextValues = Preferences & {
  localCountries: string[];
};

const PreferencesContext = React.createContext<PreferencesContextValues>({} as never);

const PreferencesProvider: FCWithChildren<PreferencesProviderProps> = (props) => {
  const { preferences, children } = props;
  const localCountries = useLocalCountries(preferences.country);

  const value = useMemo(() => ({ ...preferences, localCountries }), [preferences, localCountries]);

  return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>;
};
const usePreferences = (): PreferencesContextValues => {
  const context: PreferencesContextValues = React.useContext(PreferencesContext);
  if (context === undefined) {
    throw new Error('usePreferences must be used within a PreferencesProvider');
  }
  return context;
};

export { PreferencesProvider, usePreferences };
